export default __webpack_public_path__ + "static/media/ninth.7bd7970b.png";